import { render, staticRenderFns } from "./Timeline.vue?vue&type=template&id=28b4da70&scoped=true&"
import script from "./Timeline.vue?vue&type=script&setup=true&lang=js&"
export * from "./Timeline.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b4da70",
  null
  
)

export default component.exports